import { Box, type SxProps } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { type FC } from "react";
import {
  fromISO8601_DATE,
  toISO8601_DATE,
  type ISO8601_DATE,
} from "../../../../../../utils/iso8601";
import type { UsableAccountPersonField } from "../../../../server/supabase-segment-field-service";
import type { Condition } from "../../types";

export const DateSelectField: FC<{
  condition: Condition;
  handleFieldChange: (value: string[]) => void;
  error?: string;
  disabled?: boolean;
  segmentField?: UsableAccountPersonField;
  hidden?: boolean;
  sx?: SxProps;
}> = ({ condition, handleFieldChange, error, disabled, segmentField, hidden, sx }) => {
  return (
    <Box hidden={hidden}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DatePicker
          value={condition.values[0] ? fromISO8601_DATE(condition.values[0] as ISO8601_DATE) : null}
          onChange={(value: Date | null) => {
            handleFieldChange(value ? [toISO8601_DATE(value)!] : []);
          }}
          slotProps={{
            textField: {
              label: segmentField?.display_name,
              error: Boolean(error),
              helperText: error,
              variant: "standard",
              hidden: hidden,
              size: "small",
            },
          }}
          disabled={disabled}
          sx={sx}
        />
      </LocalizationProvider>
    </Box>
  );
};
